<template>
    <div id="sfsms">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <headers :is_finish="1" title="书法训练营短信提醒"></headers>
            <router-link class="notice_btn" to="/communication/sfrecord">发送记录</router-link>
            <div class="page_content">
                <div class="remind_info">
                    <div class="remind_item">
                        <div class="item_label">课程时间：</div>
                        <div class="item_content">{{ page_data.start_time }} 至 {{ page_data.end_time }}</div>
                    </div>
                    <div class="remind_item">
                        <div class="item_label">接收对象：</div>
                        <div class="item_content">班内开通书法的学生</div>
                    </div>
                    <div class="remind_item">
                        <div class="item_label">发送时间：</div>
                        <div class="item_content"><span class="green">每{{ page_data.week }}</span>发送短信提醒</div>
                    </div>
                    <div class="remind_item">
                        <div class="item_label">短信内容：</div>
                        <div class="item_content">{{ page_data.content }}</div>
                    </div>
                </div>
                <button class="opt_btn" @click="handleSms">{{ page_data.status ? "关闭" : "开启" }}短信提醒</button>
                <div class="page_tips" v-if="page_data.status">短信提醒已开启，将于{{ page_data.end_sms }}自动关闭短信提醒<br/>您可以在关闭后再重新开启</div>
            </div>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
    import loadings from "COMPONENTS/base/loadingS.vue";
    import headers from 'COMPONENTS/base/header.vue'
    export default {
        components: {
            loadings,headers
        },
        data() {
            return {
                loading:true,
                page_data:{},
            }
        },
        created() {
            this.getData();
        },
        methods: {
            getData(){
                this.$http.get(API_URL_HD_API + '/sf_train/tea/index/').then(res => {
                    res = res.data;
                    if (res.response == 'ok') {
                        this.page_data = res.data;
                    } else {
                        layer.tips(res.message);
                    }
                }).finally(()=>{this.loading = false});
            },
            handleSms(){
                let status = this.page_data.status == 1 ? 0 : 1;
                this.$http.post(API_URL_HD_API + '/sf_train/tea/index/',{
                    status
                }).then(res => {
                    res = res.data;
                    if (res.response == 'ok') {
                        this.getData();
                        layer.tips((status==1 ? "开启" : "关闭") +"成功");
                    } else {
                        layer.tips(res.message);
                    }
                })
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #sfsms{
        min-height: 100vh;
        background-color: #fff;
        .notice_btn{
            position: fixed;
            top: 0;
            right: 24px/$ppr;
            font-size: 30px/$ppr;
            line-height: 96px/$ppr;
            color: #fff;
            z-index: 10;
        }
        .page_content{
            padding: 28px/$ppr 24px/$ppr;
            .remind_info{
                background-color: #f5f9ff;
                border-radius: 10px/$ppr;
                padding: 28px/$ppr 24px/$ppr 32px/$ppr;
                margin-bottom: 78px/$ppr;
                .remind_item{
                    margin-bottom: 24px/$ppr;
                    font-size: 28px/$ppr;
                    line-height: 48px/$ppr;
                    display: flex;
                    .item_label{
                        width: 160px/$ppr;
                        flex-shrink: 0;
                        color: #6c7379;
                    }
                    .item_content{
                        flex-grow: 1;
                        .green{
                            color: #51ae77;
                            font-weight: bold;
                        }
                    }
                }
            }
            .opt_btn{
                display: block;
                width: 360px/$ppr;
                height: 80px/$ppr;
                margin: 0 auto 26px/$ppr;
                background-color: #5e89ef;
                color: #fff;
                font-size: 30px/$ppr;
                border-radius: 40px/$ppr;
                border: none;
            }
            .page_tips{
                text-align: center;
                font-size: 24px/$ppr;
                color: #999;
                line-height: 36px/$ppr;
            }
        }
    }
</style>